export function getNumbersList(): { value: string; label: string }[] {
    const number = [
        {
            value: "",
            label: "Hora / Aula",
        },
    ];
    for (let i = 0.5; i <= 40.0; i += 0.5) {
        number.push({
            value: i.toString(),
            label: i.toString(),
        });
    }
    return number;
}

export function getNumbersOption(): { value: string; text: string }[] {
    const number = [
        {
            value: "",
            text: "Hora / Aula",
        },
    ];
    for (let i = 0.5; i <= 40.0; i += 0.5) {
        number.push({
            value: i.toString(),
            text: i.toString(),
        });
    }
    return number;
}

export function arraysEqual(a: any[], b: any[]) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

export default interface AcademicActivityPlansItem {
    id?: any;
    activity: any;
    typeHour: any;
    hour: any;
    coverage: any;
    students: any;
    detailing: any;
    dataVigenciaInicio: any;
    dataVigenciaFim: any;
    campus: any;
    workloadValid?: any;
    hoursBookings?: any;
    tableIndex: number;
}
